module.exports = __webpack_public_path__ + "static/media/mobile_separator_01.c91decbd.webp";